import React, { useContext, useEffect } from 'react';
import navigatorLanguages from 'navigator-languages';
import { I18nProvider } from '@lingui/react';
import { i18n } from '@lingui/core';
import { dynamicI18nActivate, formatDistanceLocaleFunc } from '../../utils';
import { LOCALES, DATE_FNS_LOCALES } from '../../consts';

const IntlContext = React.createContext();

const IntlProvider = ({ children }) => {
  const preferredLanguages = navigatorLanguages();
  const currentLocale = preferredLanguages.find((lang) => LOCALES.includes(lang)) || 'en';
  const locale = DATE_FNS_LOCALES[currentLocale];

  useEffect(() => {
    dynamicI18nActivate(currentLocale);
  }, []);
  const formatDistanceLocale = formatDistanceLocaleFunc(locale);

  const intlUtils = {
    locale: LOCALES[currentLocale],
    formatDistanceLocale,
  };

  return (
    <I18nProvider i18n={i18n}>
      <IntlContext.Provider value={intlUtils}>
        {typeof children === 'function' ? children(intlUtils) : children}
      </IntlContext.Provider>
    </I18nProvider>
  );
};

const useIntl = () => {
  return useContext(IntlContext);
};

export { IntlProvider, useIntl };
